import * as ActionTypes from '../ActionTypes';

const initialState = {
    AiConfigLoading: false,
    aiConfigData: [],
    error: null,
    ModelTestingLoading: false,
    modelTestingData: []

};

export const AIConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.GET_AI_CONFIG_REQUEST:
            return {
            ...state,
            AiConfigLoading: true,
            aiConfigData: [],
            error: null,
        };
        case ActionTypes.ADD_AI_CONFIG_REQUEST:
        case ActionTypes.UPDATE_AI_CONFIG_REQUEST:
        case ActionTypes.DELETE_AI_CONFIG_REQUEST:
        return {
            ...state,
            AiConfigLoading: true,
            error: null,
        };

        case ActionTypes.GET_AI_CONFIG_SUCCESS:
        case ActionTypes.ADD_AI_CONFIG_SUCCESS:
        case ActionTypes.UPDATE_AI_CONFIG_SUCCESS:
        case ActionTypes.DELETE_AI_CONFIG_SUCCESS:
        return {
            ...state,
            AiConfigLoading: false,
            aiConfigData: action.payload?.data?.data || [],
            error: null,
        };

        case ActionTypes.GET_AI_CONFIG_ERROR:
        case ActionTypes.ADD_AI_CONFIG_ERROR:
        case ActionTypes.UPDATE_AI_CONFIG_ERROR:
        case ActionTypes.DELETE_AI_CONFIG_ERROR:
        return {
            ...state,
            AiConfigLoading: false,
            error: true,
        };

        case ActionTypes.TEST_MODEL_REQUEST:
            return {
            ...state,
            ModelTestingLoading: true,
            modelTestingData: [],
            error: null,
        };
        case ActionTypes.TEST_MODEL_SUCCESS:
        return {
            ...state,
            ModelTestingLoading: false,
            modelTestingData: action.payload?.data?.data || [],
            error: null,
        };

        case ActionTypes.TEST_MODEL_ERROR:
        return {
            ...state,
            ModelTestingLoading: false,
            error: true,
        };
        default:
            return state;
    }
};
